import {
  infiniteQueryOptions,
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import type {
  AgentInboxMarkReadInput,
  AgentInboxMarkAllReadInput,
  AgentInboxListMessagesParams,
} from '../api'
import type { IMutationArgs } from '../types'
import { agentInboxListMessagesOptionsPre } from './agent-inbox.options'
import { EAgentInboxQueryKey } from './agent-inbox.types'
import userOtcService from './agent-inbox.service'

export const useAgentInboxMarkAsRead = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AgentInboxMarkReadInput) =>
      userOtcService.agentInboxMarkAsRead(data),
    mutationKey: [EAgentInboxQueryKey.AGENT_INBOX_MARK_AS_READ],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentInboxQueryKey.AGENT_INBOX_LIST_MESSAGES],
        })
      return data
    },
  })
}

export const useAgentInboxMarkAllAsRead = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AgentInboxMarkAllReadInput) =>
      userOtcService.agentInboxMarkAllAsRead(data),
    mutationKey: [EAgentInboxQueryKey.AGENT_INBOX_MARK_ALL_AS_READ],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentInboxQueryKey.AGENT_INBOX_LIST_MESSAGES],
        })
      return data
    },
  })
}

export const useAgentInboxListMessages = (
  params: AgentInboxListMessagesParams,
) => {
  return useInfiniteQuery(
    infiniteQueryOptions(agentInboxListMessagesOptionsPre(params)),
  )
}
